"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyerOfferDtoSignatureStatusEnum = exports.BuyerOfferDtoStatusEnum = void 0;
exports.instanceOfBuyerOfferDto = instanceOfBuyerOfferDto;
exports.BuyerOfferDtoFromJSON = BuyerOfferDtoFromJSON;
exports.BuyerOfferDtoFromJSONTyped = BuyerOfferDtoFromJSONTyped;
exports.BuyerOfferDtoToJSON = BuyerOfferDtoToJSON;
exports.BuyerOfferDtoToJSONTyped = BuyerOfferDtoToJSONTyped;
var OfferUnderBuyerDto_1 = require("./OfferUnderBuyerDto");
var OfferUnderListingDto_1 = require("./OfferUnderListingDto");
var GetOriginalOfferDto_1 = require("./GetOriginalOfferDto");
/**
 * @export
 */
exports.BuyerOfferDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.BuyerOfferDtoSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * Check if a given object implements the BuyerOfferDto interface.
 */
function instanceOfBuyerOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('isCounterOffer' in value) || value['isCounterOffer'] === undefined)
        return false;
    if (!('buyers' in value) || value['buyers'] === undefined)
        return false;
    if (!('listing' in value) || value['listing'] === undefined)
        return false;
    return true;
}
function BuyerOfferDtoFromJSON(json) {
    return BuyerOfferDtoFromJSONTyped(json, false);
}
function BuyerOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'offerPrice': json['offerPrice'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
        'isCounterOffer': json['isCounterOffer'],
        'parentOfferId': json['parentOfferId'] == null ? undefined : json['parentOfferId'],
        'buyers': (json['buyers'].map(OfferUnderBuyerDto_1.OfferUnderBuyerDtoFromJSON)),
        'listing': (0, OfferUnderListingDto_1.OfferUnderListingDtoFromJSON)(json['listing']),
        'contractSubjects': json['contractSubjects'] == null ? undefined : json['contractSubjects'],
        'conditions': json['conditions'] == null ? undefined : json['conditions'],
        'counterOfferPrice': json['counterOfferPrice'] == null ? undefined : json['counterOfferPrice'],
        'totalDepositAmount': json['totalDepositAmount'] == null ? undefined : json['totalDepositAmount'],
        'totalPaid': json['totalPaid'] == null ? undefined : json['totalPaid'],
        'rejectedReason': json['rejectedReason'] == null ? undefined : json['rejectedReason'],
        'rejectedAt': json['rejectedAt'] == null ? undefined : json['rejectedAt'],
        'originalOffer': json['originalOffer'] == null ? undefined : (0, GetOriginalOfferDto_1.GetOriginalOfferDtoFromJSON)(json['originalOffer']),
    };
}
function BuyerOfferDtoToJSON(json) {
    return BuyerOfferDtoToJSONTyped(json, false);
}
function BuyerOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'offerPrice': value['offerPrice'],
        'depositAmount': value['depositAmount'],
        'settlementDate': value['settlementDate'],
        'expiresAt': value['expiresAt'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
        'isCounterOffer': value['isCounterOffer'],
        'parentOfferId': value['parentOfferId'],
        'buyers': (value['buyers'].map(OfferUnderBuyerDto_1.OfferUnderBuyerDtoToJSON)),
        'listing': (0, OfferUnderListingDto_1.OfferUnderListingDtoToJSON)(value['listing']),
        'contractSubjects': value['contractSubjects'],
        'conditions': value['conditions'],
        'counterOfferPrice': value['counterOfferPrice'],
        'totalDepositAmount': value['totalDepositAmount'],
        'totalPaid': value['totalPaid'],
        'rejectedReason': value['rejectedReason'],
        'rejectedAt': value['rejectedAt'],
        'originalOffer': (0, GetOriginalOfferDto_1.GetOriginalOfferDtoToJSON)(value['originalOffer']),
    };
}
